module.exports = __webpack_public_path__ + "static/media/28DGC4.ef9f72d4.jpg";